const AUTH_PATHS = {
  login: '/auth/login',
  signup: '/auth/signup',
  logout: '/auth/logout',
};

const CONNECTED_ACCOUNTS_PATH =
  '/accounts/users/me/connected-accounts/doters';

function resolveUrl(base, path) {
  if (!base) return '';
  try {
    const normalizedBase = `${base.trim().replace(/\/+$/, '')}/`;
    const normalizedPath = path.replace(/^\/+/, '');
    return new URL(normalizedPath, normalizedBase).href;
  } catch {
    return '';
  }
}

export function buildUnifiedAccountUrls(site, api) {
  return {
    login: resolveUrl(site, AUTH_PATHS.login),
    signup: resolveUrl(site, AUTH_PATHS.signup),
    logout: resolveUrl(site, AUTH_PATHS.logout),
    endpoint: resolveUrl(api, CONNECTED_ACCOUNTS_PATH),
  };
}
